<template>
  <BasicHeader pretitle="aqfer Marketing Data Platform" title="Named Queries" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <div class="card">
          <div class="card-body p-0">
            <Datatable 
              tableId="namedQueries"
              :columns="columns"
              uniqueField="Name"
              :data="$store.state.amdp.queries"
              :selectedItem="$store.state.amdp.currentQuery"
              :lengthChange="false" :info="false"
              v-on:selected="handleSelect"
              :compact="true"
              />  
            </div>
            <div class="card-footer">
              <span class="float-end">
                    <button type="button" :disabled ="userRoleRank < 4 ? false:true" @click="showModal({component:'AddQuery'})" class="btn btn-primary" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="userRoleRank >= 4 ? `User do not have permission to add named query. Please contact support` :`Add Named Query`"><i class='fa fa-plus'></i>
                    </button>&nbsp;
                    <button type="button" :disabled ="userRoleRank < 4 ? false:true" @click="showModal({component:'ImportNamedQuery'})" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="userRoleRank >= 4 ? `User do not have permission to add named query. Please contact support` :`Import Named Query`"><i class='fa fa-download'></i>
                    </button>&nbsp;
              </span>
            </div>
        </div>
      </div>
      <div  v-if="query" class="col-md-9">
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title text-capitalize">{{ query.Name }}</h4>
            <span class="float-end">
              <button v-if="isAdminOrManager" type="button" @click="onAdminView" class="btn btn-outline-primary" data-bs-toggle="tooltip" data-bs-placement="top" title="Switch to admin view"><i class='fa fa-user-tie'></i></button>&nbsp;
              <button type="button" @click="onCopyQuery" class="btn btn-light" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy query as JSON"><i class='fa fa-copy'></i></button>&nbsp;
              <button type="button" @click="onEditClick" class="btn btn-primary" :disabled ="userRoleRank < 4 ? false:true" data-bs-toggle="tooltip" data-bs-placement="top" :title="userRoleRank >= 4 ? `User do not have permission to edit named query. Please contact support` :`Edit Named Query `"><i class='fa fa-pen-to-square'></i></button>&nbsp;
              <button type="button" @click="onDeleteClick" class="btn btn-danger" :disabled ="userRoleRank < 4 ? false:true" data-bs-toggle="tooltip" data-bs-placement="top" :title="userRoleRank >= 4 ? `User do not have permission to delete named query. Please contact support` :`Delete Named Query `"><i class='fa fa-trash-can'></i></button>
            </span>
          </div>
          <div class="card-body p-0">
            <CodemirrorEditor 
              class="codeMirrorHeight"
              :key="query.Name"
              :editorId="query.Name"
              mode="sql"
              :refreshOn="refreshOn"
              v-model="query.QueryString"
              :readOnly="true"
              :customHeight="'50vh'"
              >
            </CodemirrorEditor>
          </div>
        </div>
        <div v-if="paramError" class="alert alert-danger" role="alert">
        {{ paramError }}
        </div>

        <div class="card shadow-sm">
          <div class="card-header bg-white border-bottom py-3">
            <h6 class="card-title mb-0 text-muted text-uppercase small fw-bold">Query Parameters</h6>
          </div>

          <div class="card-body">
            <div v-if="query.Params.length > 0">
              <FormFields :fields="queryParams" v-model="param" :refreshOn="refreshOn" :inlineField="true" />
            </div>

            <div v-else class="text-center py-3 bg-light rounded border border-dashed">
              <span class="text-muted">
                <i class="fa fa-info-circle"></i>
                This query requires no additional parameters.
              </span>
            </div>
          </div>

          <div class="card-footer bg-white py-3 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="form-check form-switch custom-switch-md">
                <input type="checkbox" class="form-check-input cursor-pointer" v-model="cache" id="cacheSwitch">
                <label class="form-check-label text-secondary" for="cacheSwitch">
                  Enable Result Caching
                </label>
              </div>
            </div>

            <div class="d-flex align-items-center justify-content-end gap-2">
              <div class="metastore-select-container position-relative flex-grow-1">
                <div class="custom-select-trigger d-flex align-items-center justify-content-between px-3 border rounded"
                  :class="{ 'disabled': runQuery, 'border-primary': isDropdownOpen }" @click="!runQuery && toggleDropdown($event)" ref="trigger">
                  <div class="d-flex align-items-center gap-2 text-truncate">
                    <i v-if="selectedMetastore" class="fa fa-circle-info text-secondary small"
                    @click.stop.prevent="isMetastoreTooltipName == selectedMetastore ? hideMetastoreTooltip() : showMetastoreTooltip($event, selectedMetastore)"></i>
                    <span :class="{ 'text-muted': !selectedMetastore }">
                      {{ selectedLabel || 'Choose Metastore...' }}
                    </span>
                  </div>
                  <i class="fa fa-chevron-down small text-muted transition-rotate ms-2" :class="{ 'rotated': isDropdownOpen }"></i>
                </div>

                <transition name="slide-up">
                  <div v-if="isDropdownOpen" class="custom-options-menu shadow-lg border rounded"
                    :class="dropDirection">
                    <div v-if="selectedMetastore" class="custom-option d-flex align-items-center justify-content-between px-3 py-2" @click="selectOption({value: null})">
                      <span class="d-flex align-items-center gap-2">
                        <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 13px; margin-top: 0.05rem;"></i>
                        <span class="text-secondary" style="font-size: 12px;">Clear Selection...</span>
                      </span>
                    </div>
                    <div v-for="option in metastoreOptions" :key="option.id" class="custom-option d-flex align-items-center justify-content-between px-3 py-2"
                      :class="{ 'selected-bg': selectedMetastore === option.value }" @click="selectOption(option)">
                      <span class="d-flex align-items-center gap-2">
                        <i class="fa fa-circle-info" :class="[isMetastoreTooltipName == option.value ? 'text-secondary' : 'text-muted opacity-75']" style="font-size: 13px; margin-top: 0.05rem"
                          @click.stop.prevent="isMetastoreTooltipName == option.value ? hideMetastoreTooltip() : showMetastoreTooltip($event, option.value)"></i>
                        <span style="font-size: 12px;">{{ option.label }}</span>
                      </span>
                    </div>
                  </div>
                </transition>
              </div>
              <transition name="fade" mode="out-in">
                <button v-if="!runQuery" key="run" type="button" @click="onRunQuery" class="btn btn-primary px-4 d-flex align-items-center gap-2">
                  <i class="fa fa-play small"></i>
                  <span>Run Query</span>
                </button>

                <button v-else key="stop" @click="onStopClick" class="btn btn-outline-danger px-4 d-flex align-items-center gap-2">
                  <div class="spinner-grow spinner-grow-sm" role="status"></div>
                  <span>Stop Execution</span>
                </button>
              </transition>
            </div>
          </div>
        </div>

        
        <div v-if="error" class="alert alert-danger" role="alert">
        {{ error }}
        </div>
        <div v-if="showOutput && !error" class="card shadow-sm">
          <div class="card-header">
            <h4 class="card-header-title">Output</h4>
            <span class="float-end">
              <button type="button" @click="exportCSV()" class="btn btn-primary">Export</button>
              <button type="button" v-if="isPartialResult" @click="exportFullData()" class="btn btn-primary ms-2">Export Full Result</button>
            </span>
          </div>
          <Datatable
              tableId="outputTable"
              :key = "outputLoading"
              :columns="outputColumns"
              :data="outputData"
              :compact="true"
              :ignoreCache="true"
              :showLoading="outputLoading" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicHeader from '../../components/BasicHeader.vue';
import Datatable from "../../components/Datatable.vue";
import CodemirrorEditor from "../../components/CodemirrorEditor.vue";
import FormFields from "../../components/FormFields.vue";
import {mapActions} from 'vuex';
import axios from 'axios';
import csv from "../../utils/tools/csv"
import * as bootstrap from 'bootstrap';
export default {
  components: { BasicHeader, Datatable, CodemirrorEditor, FormFields },
  name: "Queries",
  data() {
    return {
      columns: [
        {
          data: "Name",
          title: "Query Name",
        },
      ],
      param: {},
      error: null,
      refreshOn: false,
      runQuery: false,
      outputColumns: [""],
      outputData: [],
      showOutput: false,
      outputLoading: false,
      cache:true,
      paramError:null,
      isPartialResult:null,
      query_id:null,

      // metastore related
      isMetastoreTooltipName: null,
      isDropdownOpen: false,
      selectedMetastore: null, // JSON stringified value of the selected metastore
      metastoreOptions: [],
      dropDirection: 'opens-down',
    };
  },
  methods: {
    ...mapActions({
      showModal: "showModal",
      deleteQuery: "amdp/deleteQuery",
      fetchFullQueryFile: "amdp/fetchFullQueryFile",
      stopQueryExecutions: "amdp/stopQueryExecutions"
    }),
    handleSelect(data) {
      this.$store.dispatch("amdp/setCurrentQuery", data);
      this.showOutput = false;
      this.param={};
      this.error = null;
      this.paramError = null;
      this.isPartialResult = null;
      this.query_id = null;
    },
    hideAllTooltips() {
      document.querySelectorAll('[data-bs-original-title], [data-bs-toggle="tooltip"]').forEach(el => {
        const tooltip = bootstrap.Tooltip.getInstance(el);
        if (tooltip) tooltip.hide();
      });
    },
    onEditClick() {
      this.hideAllTooltips();
      this.$router.push("queries/"+this.query.Name);
    },
    async onRunQuery() {
      this.outputLoading=true;
      this.runQuery = true;
      let paramsString = [];
      this.error = null;
      this.paramError=null;
      this.isPartialResult = null;
      this.query_id = null;
      if (!this.cache) {
          paramsString.push("cache=false")
      }
      let runFlag = true;
      this.showOutput=true;
      this.outputColumns=[""];

      // add metastore params if selected
      if (this.selectedMetastore) {
        const metastore = JSON.parse(this.selectedMetastore);
        paramsString.push(`account=${metastore.account}`);
        paramsString.push(`region=${metastore.region}`);
        paramsString.push(`type=${metastore.type}`);
      }
      
      if (this.query.Params.length > 0) {
        this.query.Params.map((item) => {
          switch (item.rule) {
            case "required":
              if (Object.prototype.hasOwnProperty.call(this.param, item.name)
                && this.param[item.name]) {
                paramsString.push(item.name + "=" + this.param[item.name])
              } else {
                this.param[item.name] = ''
                runFlag = false;
              }
              break;
            case "optional":
              if (Object.prototype.hasOwnProperty.call(this.param, item.name)) {
                paramsString.push(item.name + "=" + this.param[item.name])
              } else {
                paramsString.push(item.name + "=" + item.value)
              }
              break;
            case "fixed":
              if (Object.prototype.hasOwnProperty.call(this.param, item.name)) {
                this.param[item.name] = ''
              } else {
                this.param[item.name] = ''
              }
              paramsString.push(item.name + "=" + item.value)
              break;
          }
        })
      }
      this.refreshOn = true
      var self = this;
      if (runFlag) {
        paramsString = paramsString.join('&')
        axios.post(self.$store.state.pailUrl + `/${self.$store.state.pailVersion}/cids/${self.$store.state.currentClient.cid}/named_queries/${this.query.Name}/execute?`
          + encodeURI(paramsString), null, {
          headers: {
            Authorization: `Bearer ${self.$store.state.accessToken}`,
          },
        }).then((response) => {
          if (response.data == null) {
            self.error= response.message
          } else {
            var query_id = response.data.query_execution_id
            if (self.$store.state.environment == "test") {
              query_id = "adReport"
            }
            if (query_id != "" && query_id != undefined) {
              self.query_id = query_id;
              self.sleep(2000).then(function () {
                self.getQueryData(query_id, 120);
              });
            } else {
              this.error= "Failed to submit query. Please retry or contact support."
              this.outputLoading = false;
              this.runQuery = false;
            }
          }
        }).catch(({response})=>{
            self.outputLoading = false;
            self.runQuery = false;
            if (response.data.error) 
              self.error = response.data.error;
            else if (response.data.message) 
              self.error =  response.data.message;
            else 
              self.error =  response.message;
        })
      }else{
            self.outputLoading = false;
            self.runQuery = false;
            self.showOutput = false;
            self.paramError="Enter mandatory params!"
      }
    },
    async getQueryData(query_id, counter) {
      var self = this;
      let qp = "";
      if (self.selectedMetastore) {
        const metastore = JSON.parse(self.selectedMetastore);
        qp = `?account=${metastore.account}&region=${metastore.region}&type=${metastore.type}`;
      }
      return axios.get(self.$store.state.pailUrl + `/${self.$store.state.pailVersion}/cids/${self.$store.state.currentClient.cid}/query_status/${query_id}${qp}`, {
        headers: {
          Authorization: `Bearer ${self.$store.state.accessToken}`,
        },
      }).then(function (response) {
        if (response.data.State && response.data.State == "FAILED" ){
            self.error=response.data.StateChangeReason
        }else if (response.data.State && (response.data.State == "QUEUED" || response.data.State == "RUNNING") && counter > 0) {
          counter--;
          self.sleep(5000).then(function () {
            self.getQueryData(query_id, counter, self.cid);
          });
        } else {
          return axios.get(self.$store.state.pailUrl + `/${self.$store.state.pailVersion}/cids/${self.$store.state.currentClient.cid}/query_executions/${query_id}${qp}`,
            {
              headers: {
                Authorization: `Bearer ${self.$store.state.accessToken}`,
              },
            }).then(function (response) {
              if (Object.prototype.hasOwnProperty.call(response.data, "message")) {
                self.error= response.data.message
              } else {
                //Show result data
                self.setOutputColumns(response.data.column_info)
                self.outputData=self.convertToTableJson(response.data);
                //If partial data is returned, then get show export option to download full data
                if (response.data.partial_result) {
                  self.isPartialResult = true;
                  self.query_id = query_id
                }
            }
            });
        }
      }).catch((error)=>{
        console.error(error)
        self.outputLoading = false;
        self.runQuery = false;
        self.error = error.response?.data?.error || error.response?.data?.message || error.message;
      });
    },

    convertToTableJson(obj) {
      var c = [];
      for (var i = 0; i < obj.data.length; i++) {
          var temp = {}
          //huge data getting from query_result_file - data are not seperated so seperating it by ,
          if(obj.data[i].length !== obj.column_info.length){
            obj.data[i] = obj.data[i].split(",")
          }
          for (var j = 0; j < obj.column_info.length; j++) {
            temp[obj.column_info[j].name] = obj.data[i][j]
          }
          c.push(temp);
      }
      this.outputLoading = false;
      this.runQuery = false;
      return c;
    },
    sleep(time) {
      return new Promise(function (resolve) {
        setTimeout(resolve, time);
      });
    },
    setOutputColumns(column_info){
      let outputColumns= column_info.map((column)=>{
        return { "data": column.name}
      })
      this.outputColumns=[...outputColumns]
    },
    onCopyQuery(){
       //Copy Query has json logic
        var copyArea = document.createElement("textarea");
        document.body.appendChild(copyArea);
        copyArea.value = JSON.stringify(this.$store.state.amdp.currentQuery);
        copyArea.select();
        document.execCommand("copy");
        document.body.removeChild(copyArea);
    },
    onDeleteClick(){
      const self = this;
      this.showModal({
        component: "confirm",
        data: {
          title: "Delete Named Query",
          message: `Are you sure you want to delete ${this.query.Name} ?`,
          async confirm() {
            try {
              const response = await self.deleteQuery(self.query);
              self.$store.dispatch("amdp/fetchQueries");
              self.$store.dispatch("amdp/setCurrentQuery", self.$store.state.amdp.queries[0]);
              return response;
            } catch (error) {
              if (error.response.data.error)
                self.error = error.response.data.error;
              else if (error.response.data.message) 
                self.error = error.response.data.message
              else self.error = error.message;
              return;
            }
          },
        },
      });
    },
    exportCSV() {    
        let header=[]
        if(this.outputData.length>0){
          Object.keys(this.outputData[0]).map((value)=>header[value]=value)
          csv.exportCSV(this.query.Name, [...header,... this.outputData])
        }else{
          this.error="No data to export"
        }      
        
    },
    onAdminView(){
      this.hideAllTooltips();
      this.$router.push(`/${this.$store.state.currentClient.cid}/amdp/admin-queries`);
    },
    onStopClick(){
            this.outputLoading = false;
            this.runQuery = false;
            this.error = null;
            this.outputData=[];
            this.isPartialResult = null;
            try{
              if(this.query_id)
                this.stopQueryExecutions(this.query_id);
            }catch (error) {
              if (error.response.data.error) 
                this.error = error.response.data.error;
              else if (error.response.data.message) 
                this.error =  error.response.data.message;
              else 
                this.error =  error.message;
            }
            this.query_id = null;
    },
    exportFullData(){
          var self=this;
          this.fetchFullQueryFile(this.query_id).then(function (resp) {
                if(resp.https){
                  var url = resp.https;
                  var a = document.createElement("a");
                  a.href = url;
                  a.click();
                  window.URL.revokeObjectURL(url);
                  a.remove(); 
                }else{
                  self.error = "Unable to download file, Try again !"
                }
            }).catch(({response})=>{
                if (response.data.error) 
                  self.error = response.data.error;
                else if (response.data.message) 
                  self.error=response.data.message;
                else 
                  self.error = response.message;
            });    
    },
    async fetchMetastores() {
      try {
        const response = await axios.get(this.$store.state.pailUrl + `/${this.$store.state.pailVersion}/cids/${this.$store.state.currentClient.cid}/metastores`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.accessToken}`,
          },
        });
        const metastores = response.data;
        this.metastoreOptions = metastores.map(metastore => {
          return {
            label: `${metastore.account}_${metastore.region}_${metastore.type}`,
            value: JSON.stringify(metastore)
          }
        });
        // sort metastore options by label
        this.metastoreOptions.sort((a, b) => {
          return a.label.localeCompare(b.label);
        });
      }
      catch (error) {
        console.error('Error fetching metastores:', error.response?.data?.error || error.message);
      }
    },

    // functions for metastore dropdown
    selectOption(option) {
      this.selectedMetastore = option.value;
      this.isDropdownOpen = false;
      this.hideMetastoreTooltip();
    },
    toggleDropdown(event) {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false;
        this.hideMetastoreTooltip(); // ← add this
        this.removeOutsideListener();
        return;
      }

      const trigger = this.$refs.trigger;
      const rect = trigger.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      const menuHeight = 200;

      this.dropDirection = spaceBelow < menuHeight && spaceAbove > spaceBelow
        ? 'opens-up'
        : 'opens-down';

      this.isDropdownOpen = true;
      this.$nextTick(() => this.addOutsideListener());
    },
    addOutsideListener() {
      this._outsideClickHandler = (e) => {
        const container = this.$refs.trigger?.closest('.metastore-select-container');
        const tooltip = document.getElementById('__metastore-tooltip__');

        // Don't close if click is inside the dropdown container OR inside the tooltip
        if (container && !container.contains(e.target) && (!tooltip || !tooltip.contains(e.target))) {
          this.isDropdownOpen = false;
          this.hideMetastoreTooltip(); // also close tooltip when dropdown closes from outside click
          this.removeOutsideListener();
        }
      };
      document.addEventListener('click', this._outsideClickHandler);
    },
    removeOutsideListener() {
      if (this._outsideClickHandler) {
        document.removeEventListener('click', this._outsideClickHandler);
        this._outsideClickHandler = null;
      }
    },
    closeDropdown() {
      this.isDropdownOpen = false;
      this.removeOutsideListener();
      this.hideMetastoreTooltip();
    },

    showMetastoreTooltip(event, value) {
      this.hideMetastoreTooltip();
      this.isMetastoreTooltipName = value;

      const metastore = JSON.parse(value);
      const fields = [
        { icon: 'fa-cloud',         label: 'Account',     val: metastore.account },
        { icon: 'fa-globe',         label: 'Region',      val: metastore.region },
        { icon: 'fa-layer-group',   label: 'Type',        val: metastore.type },
        { icon: 'fa-shield-halved', label: 'Role ARN',    val: metastore.rolearn },
        { icon: 'fa-key',           label: 'External ID', val: metastore.externalId },
        { icon: 'fa-bucket',        label: 'Log Bucket',  val: metastore.logbucket },
      ].filter(f => f.val);

      // --- Build tooltip container ---
      const tip = document.createElement('div');
      tip.id = '__metastore-tooltip__';
      Object.assign(tip.style, {
        position: 'fixed',
        zIndex: '9999',
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '6px',
        padding: '12px 14px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1), 0 2px 8px rgba(0,0,0,0.06)',
        width: '250px',
        maxHeight: '300px',
        overflowY: 'auto',
        pointerEvents: 'auto',
        opacity: '0',
        transition: 'opacity 0.15s ease, transform 0.15s ease',
        transform: 'translateX(6px)',
      });

      // --- Build header ---
      const header = document.createElement('div');
      Object.assign(header.style, {
        fontSize: '11px',
        fontWeight: '700',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: 'var(--bs-primary)',
        marginBottom: '8px',
        paddingBottom: '6px',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      });
      header.textContent = 'Metastore Details';
      tip.appendChild(header);

      // --- Build rows container ---
      const rowsContainer = document.createElement('div');
      Object.assign(rowsContainer.style, {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
      });

      fields.forEach(f => {
        // Row wrapper
        const row = document.createElement('div');
        Object.assign(row.style, {
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px',
          padding: '4px 0',
          borderBottom: '1px solid #f1f5f9',
        });

        // Icon
        const icon = document.createElement('i');
        icon.className = `fa ${f.icon}`;
        Object.assign(icon.style, {
          color: '#3b82f6',
          fontSize: '11px',
          flexShrink: '0',
          width: '13px',
          textAlign: 'center',
          marginTop: '1px',
        });

        // Text column
        const textCol = document.createElement('div');
        Object.assign(textCol.style, {
          display: 'flex',
          flexDirection: 'column',
          gap: '1px',
          minWidth: '0',
        });

        // Label
        const label = document.createElement('span');
        Object.assign(label.style, {
          fontSize: '9px',
          fontWeight: '600',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          color: 'var(--bs-secondary)',
        });
        label.textContent = f.label;

        // Value
        const val = document.createElement('span');
        Object.assign(val.style, {
          fontSize: '11px',
          color: '#1e293b',
          wordBreak: 'break-all',
          lineHeight: '1.4',
          userSelect: 'text',
          cursor: 'text',
        });
        val.textContent = f.val;

        textCol.appendChild(label);
        textCol.appendChild(val);
        row.appendChild(icon);
        row.appendChild(textCol);
        rowsContainer.appendChild(row);
      });

      tip.appendChild(rowsContainer);
      document.body.appendChild(tip);

      // --- Positioning ---
      const rect = event.target.getBoundingClientRect();
      const tipWidth = 260;
      const tipEstimatedHeight = fields.length >= 6 ? 325 : 275;
      const GAP = 8;

      const left = rect.left - tipWidth - GAP;
      const spaceBelow = window.innerHeight - rect.top;
      let top = spaceBelow < tipEstimatedHeight + GAP
        ? rect.bottom - tipEstimatedHeight
        : rect.top;

      top = Math.max(8, Math.min(top, window.innerHeight - tipEstimatedHeight - 8));

      tip.style.left = left + 'px';
      tip.style.top = top + 'px';

      // --- Animate in ---
      requestAnimationFrame(() => {
        tip.style.opacity = '1';
        tip.style.transform = 'translateX(0)';
      });
    },

    hideMetastoreTooltip() {
      this.isMetastoreTooltipName = null;
      const existing = document.getElementById('__metastore-tooltip__');
      if (existing) existing.remove();
    },
  },
  computed: {
    query() {
      return this.$store.state.amdp.currentQuery;
    },
    queryParams() {
      if (this.query) {
        return this.query.Params.map((param) => {
          return {
            name: param.name,
            label: param.name,
            placeholder:param.value,
            type: param.datatype === "string" ? "text" : "number",
            validation: param.rule === "required" ? [{ type: "required", errMsg: param.name +" is required"}] : [],
            editable: true
          }
        })
      }
      return []
    },
    isAdminOrManager() {
          return this.$store.getters.userRoles.isAqferAdmin || this.$store.getters.userRoles.isAqferManager;
    },
    userRoleRank() {
        return this.$store.getters.userRoles.userRoleRank;
    },
    selectedLabel() {
      const found = this.metastoreOptions.find(o => o.value === this.selectedMetastore);
      return found ? found.label : null;
    }
  },
  beforeMount() {
    this.$store.dispatch("amdp/fetchQueries")
    this.fetchMetastores();
  },
  beforeUnmount() {
    this.removeOutsideListener();
    this.hideMetastoreTooltip();
  },
}
</script>

<style scoped>
.codeMirrorHeight>>>.CodeMirror {
  height: 410px;
}

.form-check-input:checked {
  background-color: #2C7BE5 !important;
  border-color: #2C7BE5;
}

.form-check-input {
  background-color: #6E84A3;
}

.metastore-select-container {
  min-width: 250px;
  max-width: 300px;
  height: 40px;
  cursor: pointer;
}

.custom-select-trigger {
  height: 100%;
  min-width: 250px;
  max-width: 300px;
  user-select: none;
  font-size: 14px;
}

.custom-select-trigger.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

/* Floating dropdown — does NOT push other elements */
.custom-options-menu {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1055;
  background: white;
  max-height: 250px;
  overflow-y: scroll;
  cursor: pointer;
}

.custom-options-menu.opens-down {
  top: calc(100% + 4px);
  bottom: auto;
}

.custom-options-menu.opens-up {
  bottom: calc(100% + 4px);
  top: auto;
}

.custom-option:hover {
  background-color: #f0f4ff;
}

.selected-bg {
  background-color: #e8f0fe;
  color: var(--bs-primary);
  font-weight: 500;
}

.transition-rotate {
  transition: transform 0.2s ease;
}

.rotated {
  transform: rotate(180deg);
}

/* Slide animation */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>